import BaseComponent from './BaseComponent';
import barba from '@barba/core';
import gsap from 'gsap';
import { getKeyboardFocusableElements } from '../utils';

export default class Menu extends BaseComponent {
	constructor(elm, pageHeader) {
		super();

		// Elements
		this.pageHeader = pageHeader;
		this.elm = elm;

		this.nav = this.elm.querySelector('[data-nav]');

		this.menuToggleButton = this.pageHeader.elm.querySelector('[data-menu-toggle-button]');
		this.menuToggleButton.addEventListener('click', () => this.toggle());

		// State
		this.isOpen = false;

		this.setInitialState();

		// Close Menu when transitioning to a new page
		barba.hooks.afterEnter(({ current, next, trigger }) => {
			if (this.isOpen) {
				this.close();
			}
		});
	}

	setInitialState() {
		if (this.pageHeader.isMobile.matches) {
			gsap.set([this.nav], {
				autoAlpha: 0,
			});
		}
	}

	toggle() {
		if (!this.pageHeader.isMobile.matches) {
			return;
		}

		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}

	open(instant = false) {
		this.pageHeader.elm.classList.add('menu-open');
		this.pageHeader.showBlur();

		document.dispatchEvent(new Event('menu-open'));

		gsap.to(this.elm, {
			xPercent: -100,

			duration: instant ? 0 : 0.3,
			ease: 'sine.out',
			onComplete: () => {
				this.isOpen = true;
				this.inertElements();
				this.trapFocus(this.elm);
			},
		});

		gsap.to([this.nav], {
			autoAlpha: 1,
			duration: instant ? 0 : 0.6,
			delay: instant ? 0 : 0,
			ease: 'none',
		});
	}

	close(instant = false) {
		this.pageHeader.elm.classList.remove('menu-open');
		this.pageHeader.hideBlur();

		document.dispatchEvent(new Event('menu-close'));

		gsap.to(this.elm, {
			xPercent: 0,
			duration: instant ? 0 : 0.3,
			ease: 'sine.inOut',
			onComplete: () => {
				this.isOpen = false;
				this.uninertElements();
			},
		});

		gsap.to([this.nav], {
			autoAlpha: this.pageHeader.isMobile.matches ? 0 : 1,
			duration: instant ? 0 : 0.2,
			ease: 'none',
		});
	}

	closeMenus() {
		this.pageHeader.nav.closeMenus();
	}

	setKeyboardFocusableElements(menu = this.elm) {
		this.keyboardFocusableElements = [];

		const focusableElements = getKeyboardFocusableElements(menu);
		focusableElements.forEach((item) => {
			this.keyboardFocusableElements.push(item);
		});

		this.firstFocusableEl = this.keyboardFocusableElements[0];
		this.lastFocusableEl = this.keyboardFocusableElements[this.keyboardFocusableElements.length - 1];
	}

	trapFocus(menu) {
		this.removeTrapFocus();

		this.tabfocussed = (event) => this.tabFocus(event);
		document.addEventListener('keydown', this.tabfocussed);

		this.setKeyboardFocusableElements(menu);
	}

	tabFocus(e) {
		if (e.key === 'Escape') {
			this.close();
		}

		const isTabPressed = e.key === 'Tab';
		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			if (document.activeElement === this.firstFocusableEl) {
				if (this.pageHeader.isMobile.matches) {
					this.lastFocusableEl.focus();
					e.preventDefault();
				} else {
					this.closeMenus();
				}
			}
		} else {
			if (document.activeElement === this.lastFocusableEl) {
				if (this.pageHeader.isMobile.matches) {
					this.firstFocusableEl.focus();
					e.preventDefault();
				} else {
					this.closeMenus();
				}
			}
		}
	}

	removeTrapFocus() {
		document.removeEventListener('keydown', this.tabfocussed);
	}

	inertElements() {
		document.querySelector('main').setAttribute('inert', '');
		document.querySelector('footer.page-footer').setAttribute('inert', '');
		this.pageHeader.logo.setAttribute('inert', '');
	}

	uninertElements() {
		document.querySelector('main').removeAttribute('inert');
		document.querySelector('footer.page-footer').removeAttribute('inert');
		this.pageHeader.logo.removeAttribute('inert');
	}
}
